// 채팅방 아이콘 선택기 — 카테고리 탭 + 이모지 그리드.
// 채팅방 만들기(ChatPage)와 수정(SubNav 사이드바) 모달에서 공용으로 쓴다.
import { useState } from "react";

export const ROOM_ICON_CATEGORIES: { label: string; icons: string[] }[] = [
  { label: "업무",     icons: ["💼", "📊", "📈", "📉", "🎯", "🏆", "📋", "🗂", "🧮", "⚖️", "🪪", "🖇"] },
  { label: "소통",     icons: ["💬", "🗣", "📢", "📣", "🔔", "📞", "☎️", "📧", "✉️", "📮", "🤝", "👥"] },
  { label: "개발·기술", icons: ["💻", "🖥", "⌨️", "🖱", "⚙️", "🔧", "🛠", "🧪", "🔬", "🤖", "🛰", "🔌"] },
  { label: "디자인·미디어", icons: ["🎨", "🖌", "🖼", "📷", "🎥", "🎬", "🎵", "🎧", "🎤", "✂️", "🪄", "🎞"] },
  { label: "문서·일정", icons: ["📅", "🗓", "⏰", "⏳", "📝", "✏️", "📚", "📖", "📄", "📑", "🗞", "📰"] },
  { label: "금융·거래", icons: ["💰", "💵", "💳", "🧾", "🏦", "📦", "🛒", "🚚", "🏷", "💎", "🪙", "📤"] },
  { label: "장소·이동", icons: ["🏢", "🏠", "🏗", "🏭", "🏫", "🗺", "🌐", "✈️", "🚗", "🚀", "⛺", "🧭"] },
  { label: "음식·자연", icons: ["☕", "🍱", "🍜", "🎂", "🌱", "🍀", "🌸", "🌊", "⛰", "🌞", "🌙", "⚡"] },
  { label: "감정·기호", icons: ["❤️", "⭐", "🔥", "💡", "✨", "🎉", "🎈", "🏅", "✅", "❗", "❓", "🚩"] },
  { label: "동물·재미", icons: ["🐶", "🐱", "🐻", "🐼", "🦁", "🐟", "🦉", "🐝", "🎮", "🎲", "♟", "🧸"] },
];

export function RoomIconPicker({ value, onChange, onClear }: {
  value: string;
  onChange: (v: string) => void;
  /** 있으면 "기본값" 버튼 표시 — 종류별 기본 아이콘으로 되돌리기 */
  onClear?: () => void;
}) {
  const [cat, setCat] = useState(0);
  const current = ROOM_ICON_CATEGORIES[cat];
  return (
    <div>
      {/* 카테고리 탭 */}
      <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 8 }}>
        {ROOM_ICON_CATEGORIES.map((c, i) => (
          <button key={c.label} onClick={() => setCat(i)}
            style={{
              border: "none", cursor: "pointer", borderRadius: 999, padding: "3px 9px",
              fontSize: 11, fontWeight: i === cat ? 800 : 500,
              background: i === cat ? "var(--p-500,#6366f1)" : "var(--panel,#f3f4f6)",
              color: i === cat ? "#fff" : "var(--text-2)", transition: "all 0.1s",
            }}>
            {c.icons[0]} {c.label}
          </button>
        ))}
      </div>
      {/* 아이콘 그리드 */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 4 }}>
        {current.icons.map((em) => {
          const sel = value === em;
          return (
            <button key={em} onClick={() => onChange(em)}
              style={{
                padding: "6px 0", border: sel ? "2px solid var(--p-500)" : "1px solid var(--border)",
                borderRadius: 8, cursor: "pointer", fontSize: 18, lineHeight: 1.3,
                background: sel ? "rgba(99,102,241,0.1)" : "var(--bg-0)", transition: "all 0.1s",
              }}>
              {em}
            </button>
          );
        })}
      </div>
      {/* 직접 입력 + 기본값 */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
        <span style={{ fontSize: 11, color: "var(--text-3)" }}>직접 입력</span>
        <input className="t-input" value={value} onChange={(e) => onChange(e.target.value.slice(0, 4))}
          placeholder="🙂" style={{ width: 56, textAlign: "center", fontSize: 16, boxSizing: "border-box", padding: "3px 4px" }} />
        {value && <span style={{ fontSize: 12, color: "var(--text-3)" }}>선택됨: <span style={{ fontSize: 16 }}>{value}</span></span>}
        <div style={{ flex: 1 }} />
        {onClear && value && (
          <button onClick={onClear} title="종류별 기본 아이콘으로"
            style={{ border: "none", background: "none", color: "var(--text-3)", fontSize: 11, cursor: "pointer" }}>
            기본값으로
          </button>
        )}
      </div>
    </div>
  );
}
